import o from "react";

var e = function e() {
  return o.createElement("svg", {
    width: "30",
    height: "26",
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "hagerty-logo-compact"
  }, o.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6875 0.5L20.1519 25.5H12.0288L21.5644 0.5H29.6875Z",
    fill: "currentColor"
  }), o.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6588 0.5L8.12313 25.5H0L9.53563 0.5H17.6588Z",
    fill: "currentColor"
  }));
};

export { e as HagertyLogoCompact };